import { connect } from 'react-redux';

import { getCoworkingDescription } from 'shared/store/coworking/selectors/dump/getCoworkingDescription';

import { IApplicationState } from '../../types/redux';

import { Description as DescriptionComponent } from './Description';
import { IDescriptionProps } from './types';

export const mapStateToProps = (state: IApplicationState): IDescriptionProps => ({
  description: getCoworkingDescription(state),
});

export const Description = connect(mapStateToProps)(DescriptionComponent);
